import React from 'react';
import FuzzySearch from 'fuzzy-search';
import { APITypes } from '../../../../primary-record-types';
import { getIntl } from '../../../../utils/intl';
import SearchInput from '../../../v2BaseComponents/SearchInput';
import { StyleProp, ViewStyle } from 'react-native';

const intl = getIntl('note-search', {
    placeholder: 'Search Notes...',
});

export type NoteSearchOwnProps = {
    searchText: string;
    onSearchTextChange: (searchText: string) => void;
    isDisabled?: boolean;
    style?: StyleProp<ViewStyle>;
    testID?: string;
};

export const filterNotesBySearchText = (notes: APITypes.notesService.NoteListItem[], searchText: string) => {
    if (!searchText) return notes;

    const searcher = new FuzzySearch(notes, ['title', 'content'], {
        caseSensitive: false,
        sort: true,
    });
    return searcher.search(searchText);
};

export type NoteSearchProps = NoteSearchOwnProps;

const NoteSearch: React.FC<NoteSearchProps> = ({ searchText, onSearchTextChange, isDisabled, style, testID }) => {
    return (
        <SearchInput
            style={style}
            value={searchText}
            onChange={onSearchTextChange}
            placeholder={intl('placeholder')}
            isDisabled={isDisabled}
            testID={testID}
        />
    );
};

export default React.memo(NoteSearch);
